import { Store } from 'vuex';
import StateType from '../store/typing';
import { HttpHelper } from './http';

/**
 * The auth helper is a class all to do with making the
 * authentication side easier.
 */
export class AuthHelper {
	private static store: Store<typeof StateType>;
	private static http: HttpHelper;

	/**
	 * Set the store to the auth helper.
	 *
	 * @param store Store instance.
	 */
	public static setData(store: Store<typeof StateType>, http: HttpHelper): void {
		this.store = store;
		this.http = http;
	}

	/**
	 * This function will attempt to make an access request, if
	 * it succeeds then it will put the data into the store and
	 * proceed, if it fails, the user will be directed to the
	 * login page.
	 */
	public static async validateLogin(): Promise<void> {

		// Define the global this check.
		(globalThis as any).isStartup = true;

		// Step 2 - Attempt to make access request.
		const response = await this.http.post('/api/access', [], { autoRefresh: 'auto' });
		if (response.status !== 200) return;

		// Step 3 - Set the data to the store.
		const result = await response.json();
		this.store.dispatch('account/set', result);

		// Set global this check as false.
		(globalThis as any).isStartup = false;
	}
}
